// @ts-nocheck
(function () {
  if (typeof VenoBox === 'undefined') {
    console.error('[VenoBox] library not loaded');
    return;
  }

  // The HTML already has class="vbox-item" baked in (Shogun-injected).
  // VenoBox's init skips any element that already has vbox-item, so it never
  // attaches .settings or a click handler. Strip it first so init runs clean.
  document.querySelectorAll('.venobox').forEach(function (el) {
    el.classList.remove('vbox-item');
  });

  new VenoBox({ selector: '.venobox' });
  // VenoBox now attaches its own click handlers with e.preventDefault() + open(obj)
})();
